module.exports = __webpack_public_path__ + "static/img/depot_join.e264a652.png";